import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportSecurityModelsUnrecognizedDialogComponent } from '@irb/irb-models/import-security-model-unrecognized-dialog/import-security-model-unrecognized-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportSecurityModelsUnrecognizedGridLayoutService implements GridLayoutService<ImportSecurityModelsUnrecognizedDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Symbol/Cusip',            
            field: 'securitySymbol'
        }];
    }
}
